/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DatalistAnagrafica, DocumentoProgetto } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProgettoService } from '@shared/services/progetto.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneProgettoModalUploadDocumentoComponent } from '../modal-upload-documento/modal-upload-documento.component';

@Component({
    selector: 'app-toolkit-progetto-tab-documenti',
    templateUrl: './tab-documenti.component.html',
})
export class ToolkitGestioneProgettoTabDocumentiComponent implements OnInit{

    @Input() canEdit: boolean;
    @Input() datalist: DatalistAnagrafica;
    @Input() items: DocumentoProgetto[] = [];

    constructor(
        private modalService: NgbModal,
        private progettoService: ProgettoService,
        private utilsService: UtilsService,
    ) { }

    ngOnInit(): void {
        this.progettoService.documentoProgettoByIdProgetto(this.progettoService.progettoSession.idProgetto).subscribe(response => {
            this.items = response;
        });
    }
    public documentoProgettoDownload(item: DocumentoProgetto) {
        this.progettoService.downloadDocumento(item).subscribe();
    }

    public addItem() {
        const modal = this.modalService.open(ToolkitGestioneProgettoModalUploadDocumentoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.result.then(result => {
            if (result.file) {
                this.progettoService.insertDocumento(result.file, this.progettoService.progettoSession.idProgetto, result.form.getRawValue()).subscribe(responseInsert => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.progettoService.documentoProgettoByIdProgetto(this.progettoService.progettoSession.idProgetto).subscribe(response => {
                        this.items = response;
                    });
                });
            }
        }).catch(e => {});
    }

    public editItem(documento: DocumentoProgetto) {
        const modal = this.modalService.open(ToolkitGestioneProgettoModalUploadDocumentoComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Modifica';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = documento;
        modal.result.then(result => {
            if (result) {
                this.progettoService.updateDocumentoProgetto(result.form.getRawValue()).subscribe(responseUpdate => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.progettoService.documentoProgettoByIdProgetto(this.progettoService.progettoSession.idProgetto).subscribe(response => {
                        this.items = response;
                    });                
                });
            }
        }).catch(e => {});
    }

    public deleteItem(idDocumento: number) {
        this.progettoService.deleteDocumento(idDocumento).subscribe(responseDelete => {
            this.progettoService.documentoProgettoByIdProgetto(this.progettoService.progettoSession.idProgetto).subscribe(response => {
                this.items = response;
            });
        });
    }

}
